import { BaseElement, Descendant } from 'slate';

// Define custom elements
export type CustomElement = BaseElement & {
  type:
    | 'block-quote'
    | 'bulleted-list'
    | 'list-item'
    | 'numbered-list'
    | 'link'
    | 'heading-one'
    | 'heading-two'
    | 'heading-three'
    | 'heading-four'
    | 'heading-five'
    | 'heading-six'
    | 'paragraph'
    | 'title'
    | 'placeholder';
  url?: string;
  children: Descendant[];
};

type ElementAttributes = {
  type: CustomElement['type'];
  url?: string;
};

type TextAttributes = {
  code?: boolean;
  strikethrough?: boolean;
  italic?: boolean;
  bold?: boolean;
  underline?: boolean;
};

export const ELEMENT_TAGS: Record<
  string,
  (el: HTMLElement) => ElementAttributes
> = {
  A: (el) => ({ type: 'link', url: el.getAttribute('href') ?? undefined }),
  BLOCKQUOTE: () => ({ type: 'block-quote' }),
  H1: () => ({ type: 'heading-one' }),
  H2: () => ({ type: 'heading-two' }),
  H3: () => ({ type: 'heading-three' }),
  H4: () => ({ type: 'heading-four' }),
  H5: () => ({ type: 'heading-five' }),
  H6: () => ({ type: 'heading-six' }),
  LI: () => ({ type: 'list-item' }),
  OL: () => ({ type: 'numbered-list' }),
  P: () => ({ type: 'paragraph' }),
  UL: () => ({ type: 'bulleted-list' }),
};

export const TEXT_TAGS: Record<string, () => TextAttributes> = {
  CODE: () => ({ code: true }),
  DEL: () => ({ strikethrough: true }),
  EM: () => ({ italic: true }),
  I: () => ({ italic: true }),
  S: () => ({ strikethrough: true }),
  STRONG: () => ({ bold: true }),
  U: () => ({ underline: true }),
};
